<template>
  <svg :width="`${size}`" :height="`${size}`">
    <use
      xmlns:xlink="http://www.w3.org/1999/xlink"
      :xlink:href="`${basePath}#${name}`"
    ></use>
  </svg>
</template>

<script>
import basePath from "@/assets/image/sprite-svg.svg";

export default {
  name: "icon",

  props: {
    name: {
      type: String,
      default: "phone"
    },
    size: {
      type: String,
      default: "18"
    }
  },

  computed: {
    basePath: () => basePath
  }
};
</script>
